import { languageToLocale } from "./locale";
import { capitalizeFirstLetter } from "./string";

export function getAge(birthday: string) {
  if (birthday == null) {
    return undefined;
  }
  var today = new Date();
  var birthDate = new Date(birthday);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export function dateToString(language: string, date: Date) {
  return new Date(date).toLocaleDateString(languageToLocale(language).code, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function datetimeToString(language: string, date: Date) {
  return new Date(date).toLocaleDateString(languageToLocale(language).code, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function timeToString(language: string, date: Date) {
  return new Date(date).toLocaleTimeString(languageToLocale(language).code, {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function datetimeToLongString(language: string, date: Date) {
  return capitalizeFirstLetter(
    new Date(date).toLocaleDateString(language, {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }),
  );
}

export function dateToLongString(language: string, date: Date) {
  return capitalizeFirstLetter(
    new Date(date).toLocaleDateString(language, {
      day: "numeric",
      month: "long",
      year: "numeric",
    }),
  );
}
